import anime from 'animejs';

/* custom helpers */
import {Cookie} from './../helpers/Cookie';

/** ----------------------------------------
 Notification
 ---------------------------------------- */
/**
 * This class will handle the closure of the
 * notification within the DOM.
 */
export class Notification extends Cookie {
    /**
     * @notification    stores the notification element
     * @cookie          cookie once notification closed
     * @init            calls the init method
     */
    constructor() {
        super();
        this.notification = '';
        this.cookie = new Cookie({
            name: 'show_notification',
            value: 'closed',
            days: 1
        });
        this.init();
    }

    /** ----------------------------------------
     Close Notification
     ---------------------------------------- */
    closeNotification() {
        let close = this.notification.querySelector('.notification__close');
        close.addEventListener('click', () => {
            this.animateClose();
        });
    }

    /** ----------------------------------------
     Animate Close
     ---------------------------------------- */
    animateClose() {
        let _this = this;
        let close = anime({
            targets: this.notification,
            height: 0,
            duration: 500,
            easing: 'linear'
        });
        close.finished.then(() => {
            _this.notification.parentNode.removeChild(this.notification);
            _this.cookie.setCookie();
        });
    }

    /** ----------------------------------------
     Init
     ---------------------------------------- */
    /**
     * This function is called within the
     * constructor and will initiate once the
     * class is loaded.
     */
    init() {
        this.notification = document.querySelector('.notification');
        if (this.notification && !this.notification.classList.contains('notification--ghost') && !this.notification.classList.contains('notification--hidden'))
            this.closeNotification();
    }
}